import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import RequestsByWeekListByWorkflow from './components/week/RequestsByWeekListByWorkflow';
import RequestsByMonthListByWorkflow from './components/month/RequestsByMonthListByWorkflow';

function RequestsByWorkflow() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Requests by workflow"
      MonthList={RequestsByMonthListByWorkflow}
      WeekList={RequestsByWeekListByWorkflow}
      storageKey="report-group-by"
    />
  );
}

export default RequestsByWorkflow;
